import { UserActions } from 'store/actions/user';

export default {
  user: (state = null, action) => (
    action.type === UserActions.SET_USER ? action.payload : state
  ),
  email: (state = null, action) => (
    action.type === UserActions.SET_EMAIL_ADDRESS ? action.payload : state
  ),
  accountId: (state = null, action) => (
    action.type === UserActions.SET_ACCOUNT_ID ? action.payload : state
  ),
  emailVerified: (state = false, action) => (
    action.type === UserActions.SET_EMAIL_VERIFIED ? action.payload : state
  ),
};
